<template>
  <b-modal ref="modal" v-bind="$attrs" v-on="$listeners">
    <slot v-if="!isEducational" />
    <educational-unavailable v-else :variant="variant" />
  </b-modal>
</template>

<script>
// A <b-modal> whose body is student-gated: renders its slot for normal users,
// or the educational-unavailable upsell card for students — so the body never
// mounts (or fetches) for them. Transparently forwards b-modal props, events,
// v-model (visible/change) and the show/hide/toggle methods, so it is a drop-in
// replacement for <b-modal>. Body-only gate; named header/footer slots are out
// of scope (all current gated modals use hide-footer + title prop).
import { mapGetters } from 'vuex';

export default {
  name: 'EducationalGatedBModal',
  inheritAttrs: false,
  model: { prop: 'visible', event: 'change' },
  props: {
    variant: {
      type: String,
      default: 'blocked',
      validator: (v) => ['blocked', 'promo'].includes(v),
    },
  },
  computed: {
    ...mapGetters({ isEducational: 'auth/isStudent' }),
  },
  methods: {
    show() { this.$refs.modal.show(); },
    hide() { this.$refs.modal.hide(); },
    toggle() { this.$refs.modal.toggle(); },
  },
};
</script>
